(() => {
  if (window.sikVolumeTwoReaderLoaded) return;
  window.sikVolumeTwoReaderLoaded = true;
  const initialise = (root) => {
    if (root.dataset.sikInitialised) return;
    const sampleNode = root.querySelector('[data-sik-book-samples]');
    const dialog = root.querySelector('[data-sik-reader-dialog]');
    if (!sampleNode || !dialog || typeof dialog.showModal !== 'function') return;
    let data;
    try { data = JSON.parse(sampleNode.textContent); } catch (error) { return; }
    if (!Array.isArray(data.pages) || data.pages.length !== 7) return;
    root.dataset.sikInitialised = 'true';
    const decodeText = value => {
      const field = document.createElement('textarea');
      field.innerHTML = String(value || '');
      return field.value;
    };
    const pages = data.pages.map(page => ({
      ...page,
      alt: decodeText(page.alt),
      openLabel: decodeText(page.openLabel),
      text: decodeText(page.text)
    }));
    const labels = Object.fromEntries(Object.entries(data.labels).map(([key, value]) => [key, decodeText(value)]));
    const selections = [[0, 1], [2, 3], [4, 5], [5, 6]];
    const chapterButtons = Array.from(root.querySelectorAll('[data-sik-chapter]'));
    const previewLinks = Array.from(root.querySelectorAll('[data-sik-preview-page]'));
    const spread = root.querySelector('[data-sik-spread]');
    const turnImage = root.querySelector('[data-sik-turn] img');
    const spreadPrev = root.querySelector('[data-sik-spread-prev]');
    const spreadNext = root.querySelector('[data-sik-spread-next]');
    const spreadStatus = root.querySelector('[data-sik-spread-status]');
    const readerImage = root.querySelector('[data-sik-reader-image]');
    const readerPaper = root.querySelector('[data-sik-reader-paper]');
    const readerBody = root.querySelector('[data-sik-reader-body]');
    const readerPrev = root.querySelector('[data-sik-reader-prev]');
    const readerNext = root.querySelector('[data-sik-reader-next]');
    const zoomButton = root.querySelector('[data-sik-reader-zoom]');
    const textButton = root.querySelector('[data-sik-reader-text]');
    const transcript = root.querySelector('[data-sik-reader-transcript]');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    let selection = 0;
    let pageIndex = 0;
    let turnTimeout = 0;
    let openTrigger = null;
    let touchStart = null;
    const assignImage = (image, page) => {
      image.src = page.src;
      image.alt = page.alt;
    };
    const renderSelection = (next, animate = true) => {
      const destination = Math.max(0, Math.min(selections.length - 1, next));
      const previous = selection;
      selection = destination;
      clearTimeout(turnTimeout);
      spread.classList.remove('is-turning', 'is-turning-back');
      if (animate && previous !== destination && !reducedMotion.matches) {
        turnImage.src = pages[selections[previous][1]].src;
        void spread.offsetWidth;
        spread.classList.add(destination > previous ? 'is-turning' : 'is-turning-back');
        turnTimeout = window.setTimeout(() => spread.classList.remove('is-turning', 'is-turning-back'), 600);
      }
      selections[selection].forEach((index, side) => {
        const link = previewLinks[side];
        const page = pages[index];
        link.href = page.src;
        link.dataset.sikPageIndex = String(index);
        link.setAttribute('aria-label', page.openLabel);
        assignImage(link.querySelector('img'), page);
      });
      const activeChapter = Math.min(selection, 2);
      chapterButtons.forEach((button, index) => {
        button.classList.toggle('is-active', index === activeChapter);
        button.setAttribute('aria-pressed', String(index === activeChapter));
      });
      spreadPrev.disabled = selection === 0;
      spreadNext.disabled = selection === selections.length - 1;
      spreadStatus.textContent = `${labels.selection} ${selection + 1} ${labels.of} ${selections.length}`;
    };
    const setZoom = (zoomed) => {
      dialog.classList.toggle('is-zoomed', zoomed);
      zoomButton.setAttribute('aria-pressed', String(zoomed));
      zoomButton.textContent = zoomed ? labels.fit : labels.zoom;
      readerBody.scrollTop = 0;
      readerBody.scrollLeft = 0;
    };
    const renderPage = (next, animate = true) => {
      pageIndex = Math.max(0, Math.min(pages.length - 1, next));
      assignImage(readerImage, pages[pageIndex]);
      transcript.textContent = pages[pageIndex].text || pages[pageIndex].alt;
      readerPrev.disabled = pageIndex === 0;
      readerNext.disabled = pageIndex === pages.length - 1;
      root.querySelector('[data-sik-reader-status]').textContent = `${labels.page} ${pages[pageIndex].number} · ${pageIndex + 1} ${labels.of} ${pages.length}`;
      readerBody.scrollTop = 0;
      readerBody.scrollLeft = 0;
      readerPaper.classList.remove('is-flipping');
      if (animate && !reducedMotion.matches) {
        void readerPaper.offsetWidth;
        readerPaper.classList.add('is-flipping');
      }
      if (pages[pageIndex + 1]) {
        const preload = new Image();
        preload.src = pages[pageIndex + 1].src;
      }
    };
    const setTextView = (textView) => {
      setZoom(false);
      readerPaper.hidden = textView;
      transcript.hidden = !textView;
      zoomButton.disabled = textView;
      textButton.setAttribute('aria-pressed', String(textView));
      textButton.setAttribute('aria-label', textView ? labels.image : labels.text);
      textButton.title = textView ? labels.image : labels.text;
    };
    const openReader = (index, trigger) => {
      openTrigger = trigger;
      setTextView(false);
      renderPage(index, false);
      dialog.showModal();
      document.body.classList.add('sik-v2-reader-open');
    };
    chapterButtons.forEach((button) => {
      button.disabled = false;
      button.addEventListener('click', () => renderSelection(Number(button.dataset.sikChapter)));
    });
    root.querySelectorAll('[data-sik-enhancement]').forEach((element) => { element.hidden = false; });
    spreadPrev.addEventListener('click', () => renderSelection(selection - 1));
    spreadNext.addEventListener('click', () => renderSelection(selection + 1));
    previewLinks.forEach((link) => link.addEventListener('click', (event) => {
      event.preventDefault();
      openReader(Number(link.dataset.sikPageIndex), link);
    }));
    root.querySelector('[data-sik-open-reader]').addEventListener('click', (event) => openReader(selections[selection][0], event.currentTarget));
    root.querySelector('[data-sik-reader-close]').addEventListener('click', () => dialog.close());
    readerPrev.addEventListener('click', () => renderPage(pageIndex - 1));
    readerNext.addEventListener('click', () => renderPage(pageIndex + 1));
    zoomButton.addEventListener('click', () => setZoom(!dialog.classList.contains('is-zoomed')));
    textButton.addEventListener('click', () => setTextView(textButton.getAttribute('aria-pressed') !== 'true'));
    dialog.addEventListener('close', () => {
      document.body.classList.remove('sik-v2-reader-open');
      if (openTrigger && openTrigger.isConnected) openTrigger.focus({ preventScroll: true });
    });
    dialog.addEventListener('keydown', (event) => {
      if (event.altKey || event.ctrlKey || event.metaKey || dialog.classList.contains('is-zoomed')) return;
      if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
        event.preventDefault();
        renderPage(pageIndex + (event.key === 'ArrowRight' ? 1 : -1));
      }
    });
    dialog.addEventListener('click', (event) => {
      if (event.target !== dialog) return;
      const bounds = dialog.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
    });
    readerBody.addEventListener('touchstart', (event) => {
      if (event.touches.length !== 1 || dialog.classList.contains('is-zoomed')) { touchStart = null; return; }
      touchStart = { x: event.touches[0].clientX, y: event.touches[0].clientY };
    }, { passive: true });
    readerBody.addEventListener('touchend', (event) => {
      if (!touchStart || !event.changedTouches.length) return;
      const dx = event.changedTouches[0].clientX - touchStart.x;
      const dy = event.changedTouches[0].clientY - touchStart.y;
      touchStart = null;
      if (Math.abs(dx) > 65 && Math.abs(dx) > Math.abs(dy) * 1.8) renderPage(pageIndex + (dx < 0 ? 1 : -1));
    }, { passive: true });
    root.addEventListener('sik:reader:destroy', () => {
      clearTimeout(turnTimeout);
      if (dialog.open) dialog.close();
      document.body.classList.remove('sik-v2-reader-open');
    });
    renderSelection(0, false);
  };
  const start = (scope = document) => {
    if (scope.matches && scope.matches('[data-sik-book-reader]')) initialise(scope);
    scope.querySelectorAll('[data-sik-book-reader]').forEach(initialise);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => start());
  else start();
  document.addEventListener('shopify:section:load', (event) => start(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('[data-sik-book-reader]').forEach((root) => root.dispatchEvent(new Event('sik:reader:destroy')));
  });
})();
